export enum UserRole {
  SUPER_ADMIN = 'super_admin',
  PARTNER = 'partner',
  MANAGER = 'manager',
  ADMIN = 'admin',
  FRONT_DESK_OFFICER = 'front_desk_officer',
  STAFF = 'staff',
  HR = 'HR',
  ACCOUNTANT = 'accountant',
  MARKETING = 'marketing',
  HOUSEKEEPER = 'housekeeper'
}

export const UserRoleList = [
  {
    id: 1,
    title: 'Manager',
    value: UserRole.MANAGER
  },
  {
    id: 2,
    title: 'Admin',
    value: UserRole.ADMIN
  },
  {
    id: 3,
    title: 'Front desk officer',
    value: UserRole.FRONT_DESK_OFFICER
  },
  {
    id: 4,
    title: 'Staff',
    value: UserRole.STAFF
  },
  {
    id: 5,
    title: 'HR',
    value: UserRole.HR
  },
  {
    id: 6,
    title: 'Accountant',
    value: UserRole.ACCOUNTANT
  },
  {
    id: 7,
    title: 'Marketing',
    value: UserRole.MARKETING
  },
  {
    id: 8,
    title: 'Housekeeper',
    value: UserRole.HOUSEKEEPER
  },
  {
    id: 9,
    title: 'Partner',
    value: UserRole.PARTNER
  }
];
